import { memo } from "react";
import { formatCurrency, transformDateToLocalDateString } from "helpers";
import Tooltip from "ui/components/Tooltip/Tooltip";

export interface OfferCellOffer {
  id?: string;
  offerNumber?: string | null;
  offerDate?: Date | null;
  dueDate?: Date | null;
  durationDays?: number | null;
  total?: number | null;
  status?: { id: string; name: string; color: string } | null;
  offerSaleStatusId?: string | null;
  offerRentStatusId?: string | null;
}

export interface OfferCellProps {
  offer: OfferCellOffer | null | undefined;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const OfferCell: React.FC<OfferCellProps> = ({ offer, onClick }) => {
  if (!offer || !offer.offerNumber) return <></>;

  return (
    <Tooltip
      decorate={
        <div
          className="text-sm font-medium text-sky-600 hover:text-sky-900 cursor-pointer truncate"
          onClick={onClick}
        >
          {offer.offerNumber}
        </div>
      }
      position="bottom-left"
      size="medium"
    >
        <div className="min-w-[220px]">
          <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Detalji ponude</div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Broj ponude</span>
            <span className="font-medium">{offer.offerNumber}</span>
          </div>
          {/* {offer.status && (
            <div className="flex justify-between text-sm mb-1 items-center">
              <span className="text-slate-300">Status</span>
              <Badge
                text={offer.status.name}
                variant={getStatusBadgeVariant(offer.status.color)}
                height="small"
                showDot={true}
              />
            </div>
          )} */}
          {offer.offerDate && (
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Datum ponude</span>
              <span className="font-medium">{transformDateToLocalDateString(offer.offerDate)}</span>
            </div>
          )}
          {offer.dueDate && (
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Datum dospijeća</span>
              <span className="font-medium">{transformDateToLocalDateString(offer.dueDate)}</span>
            </div>
          )}
          {offer.durationDays != null && (
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Broj dana</span>
              <span className="font-bold text-sky-400">{offer.durationDays}</span>
            </div>
          )}
          {offer.total != null && offer.total > 0 && (
            <>
              <div className="border-t border-slate-600 my-2"></div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-300">Ukupno</span>
                <span className="font-bold text-green-400">{formatCurrency.format(offer.total)}</span>
              </div>
            </>
          )}
        </div>
      </Tooltip>
  );
};

export default memo(OfferCell);
